import React from 'react'

import clsx from 'clsx'

import CircularProgress from 'components/CircularProgress'
import { revealSEOUrl } from 'helpers/SEOHelper'
import { STATUS } from 'helpers/spa'

import FormControlLabel from '../../../FormControlLabel'

import classes from './CategoryLeaders.module.scss'

const CategoryLeaders = ({ facet, onItemClick, status }) => {
  const loading = status === STATUS.loading

  return (
    <div className={clsx('CategoryLeaders', classes.root)}>
      <FormControlLabel
        disabled={loading || facet[0].count === 0}
        classes={{ root: classes.formControlLabel }}
        fullWidth
        isChecked={facet[0].selected}
        onClick={(event, { isChecked }) =>
          onItemClick(event, {
            facet: 'category_leaders_facet',
            href: revealSEOUrl(facet[0].href),
            value: facet[0].value,
            isChecked,
          })
        }
        label={
          <>
            {loading ? (
              <CircularProgress className={classes.circularProgress} color="inherit" size={16} />
            ) : (
              !facet[0].selected && facet[0].count !== null && <span className={classes.count}>({facet[0].count})</span>
            )}
          </>
        }
        type="image"
      />
    </div>
  )
}

export default CategoryLeaders
